import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-enquiry",
  "use": "icon-arrow-enquiry-usage",
  "viewBox": "0 0 13.545 8.578",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.545 8.578\" id=\"icon-arrow-enquiry\">\n  <path id=\"icon-arrow-enquiry_np_arrow_1569918_000000\" d=\"M33.545,35.289a.528.528,0,0,0-.127-.31l-3.612-3.838a.452.452,0,0,0-.638-.018.466.466,0,0,0-.018.638l2.9,3.076h-11.6a.451.451,0,1,0,0,.9h11.6l-2.9,3.076a.473.473,0,0,0,.018.638.452.452,0,0,0,.638-.018L33.418,35.6a.4.4,0,0,0,.127-.31Z\" transform=\"translate(-20 -31)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/arrow-enquiry.svg
// module id = 96
// module chunks = 0 1 2